<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
    },
    data() {
        return {
            data: {},
            routeName: 'reservation',
        };
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();
            vm.onFocus();
        },
        newData() {
            var vm = this;

            var data = {
                ref_no: null,
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;
            vm.$loading.on('reservation_list_sign_in');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Reservation.status(postData);

                var data = resp.data;

                vm.$flash.success(data.message);

                vm.success(vm.data);
                vm.$sidebar.hide();
            } catch (err) {
                vm.$flash.error(err.response.data.message);
            }
            vm.$loading.off('reservation_list_sign_in');
        },
        _createPostData: function (data) {
            data.status = 'going';

            return data;
        },
        onFocus() {
            setTimeout(() => {
                const input = this.$refs.refNoInput;
                if (input) {
                    input.focus();
                    input.select();
                }
            }, 500);
        }
    }
}
</script>

<template>

    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12">
                        <label for="ref_no" class="form-label">{{ $t('reservation.label.ref_no') }}</label>
                        <input type="text" v-model="data.ref_no" class="form-control" id="ref_no" ref="refNoInput"
                            :placeholder="$t('reservation.placeholder.ref_no')" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create')))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="info" class="w-100" @click="submit"
                                    :disabled="$loading.get('reservation_list_sign_in')">
                                    <loading :loading="$loading.get('reservation_list_sign_in')" variant="light"
                                        type="button">
                                        <i class="mdi mdi-qrcode-scan align-bottom me-1"></i>
                                        {{ $t('reservation.btn.signin') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>